import { render, staticRenderFns } from "./passwordValidation.vue?vue&type=template&id=b0a4b13a&"
import script from "./passwordValidation.vue?vue&type=script&lang=js&"
export * from "./passwordValidation.vue?vue&type=script&lang=js&"
import style0 from "./passwordValidation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports